import React, { ReactNode } from 'react';

import { ErrorBoundary } from './ErrorBoundary';

interface GlobalErrorHandlerProps {
  children: ReactNode;
}

const GlobalErrorHandler: React.FC<GlobalErrorHandlerProps> = ({ children }) => {
  return (
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorHandler;
